<h2 style="padding-left: 16px !important">{{ title | translate }}</h2>
<section
    fxLayout="column"
    style="flex-grow: 1; flex: 1; max-height: 100%"
    fxLayoutAlign="start stretch"
    fxLayoutGap="8px">
    <div style="padding-left: 16px; padding-right: 40px; line-height: 22px; font-size: 15px">{{ confirmMessage }}</div>
    @defer (when optionValues()?.length > 0) {
        <section
            style="margin-right: 8px; padding-left: 32px; padding-top: 16px; display: flex; flex-direction: column">
            @for (item of optionValues(); track item.value) {
                <div style="padding-bottom: 16px; width: 100%">
                    @defer (when item.type == 'boolean') {
                        <mat-checkbox [(ngModel)]="item.value">{{ item.title | translate }}</mat-checkbox>
                    }
                    @defer (when item.type == 'string') {
                        <mat-form-field>
                            <mat-label>{{ item.title | translate }}</mat-label>
                            <input
                                matInput
                                [(ngModel)]="item.value"
                                [required]="item.required"
                                placeholder="{{ item.title | translate }}" />
                        </mat-form-field>
                    }
                    @defer (when item.type == 'number') {
                        <mat-form-field>
                            <mat-label>{{ item.title | translate }}</mat-label>
                            <input
                                matInput
                                type="number"
                                [(ngModel)]="item.value"
                                [required]="item.required"
                                placeholder="{{ item.title | translate }}" />
                        </mat-form-field>
                    }
                    @defer (when item.type == 'date') {
                        <mat-form-field>
                            <mat-label>{{ item.title | translate }}</mat-label>
                            <input matInput [matDatepicker]="picker" [(ngModel)]="item.value" />
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    }
                </div>
            }
        </section>
    }
    <div mat-dialog-actions class="pt-24" fxLayoutAlign="flex-end">
        <button matButton="tonal" #yesBtn [disabled]="isNotValid()" cdkFocusInitial (click)="onYesClick()">
            <span>{{ yesCaption | translate }}</span>
        </button>
        <button matButton="tonal" #noBtn tabindex="0" (click)="onNoClick()">
            <span>{{ noCaption | translate }}</span>
        </button>
        @if (showCancel) {
            <button matButton="tonal" #cancelBtn tabindex="0" (click)="onCancelClick()">
                <span>{{ 'GENERAL.BUTTON.CANCEL' | translate }}</span>
            </button>
        }
    </div>
</section>
